import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']
let store = {}

void (function updateModules() {
  store = normalizeRoot(require('../src/store/index.ts'), 'store/index.ts')

  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../src/store/ai-report-edit.ts'), 'ai-report-edit.ts')
  resolveStoreModules(require('../src/store/ai-report-form.ts'), 'ai-report-form.ts')
  resolveStoreModules(require('../src/store/board.ts'), 'board.ts')
  resolveStoreModules(require('../src/store/construction-kind.ts'), 'construction-kind.ts')
  resolveStoreModules(require('../src/store/content-tree-template.ts'), 'content-tree-template.ts')
  resolveStoreModules(require('../src/store/content-ui.ts'), 'content-ui.ts')
  resolveStoreModules(require('../src/store/content.ts'), 'content.ts')
  resolveStoreModules(require('../src/store/customer.ts'), 'customer.ts')
  resolveStoreModules(require('../src/store/daily-report.ts'), 'daily-report.ts')
  resolveStoreModules(require('../src/store/holiday.ts'), 'holiday.ts')
  resolveStoreModules(require('../src/store/image-editor.ts'), 'image-editor.ts')
  resolveStoreModules(require('../src/store/initial-setting.ts'), 'initial-setting.ts')
  resolveStoreModules(require('../src/store/member-allocation.ts'), 'member-allocation.ts')
  resolveStoreModules(require('../src/store/member.ts'), 'member.ts')
  resolveStoreModules(require('../src/store/notification.ts'), 'notification.ts')
  resolveStoreModules(require('../src/store/policy.ts'), 'policy.ts')
  resolveStoreModules(require('../src/store/product-tour.ts'), 'product-tour.ts')
  resolveStoreModules(require('../src/store/project-member.ts'), 'project-member.ts')
  resolveStoreModules(require('../src/store/project.ts'), 'project.ts')
  resolveStoreModules(require('../src/store/public-content.ts'), 'public-content.ts')
  resolveStoreModules(require('../src/store/report-editor.ts'), 'report-editor.ts')
  resolveStoreModules(require('../src/store/report.ts'), 'report.ts')
  resolveStoreModules(require('../src/store/schedule.ts'), 'schedule.ts')
  resolveStoreModules(require('../src/store/sharing-content.ts'), 'sharing-content.ts')
  resolveStoreModules(require('../src/store/search/content.ts'), 'search/content.ts')
  resolveStoreModules(require('../src/store/search/customer.ts'), 'search/customer.ts')
  resolveStoreModules(require('../src/store/search/project.ts'), 'search/project.ts')
  resolveStoreModules(require('../src/store/search/report.ts'), 'search/report.ts')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function resolveStoreModules(moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs|ts)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const storeModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(storeModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeRoot(moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeState(moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule(moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)
    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function getStoreModule(storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty(storeModule, moduleData, property) {
  if (!moduleData) return

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
